.countdown {
  position: fixed;
  left: 2rem;
  bottom: 2rem;
}
